import _ from "lodash";

import { toSalesPeopleRows } from "../../../../components/Functional/SalesPeopleSplitEditor/salesPeopleSplitEditorUtils";

const SOURCING_PEOPLE_FIELD = "consignmentSalesPeople";

// The form holds sourcing people as plain { salesUserId, split } rows so the
// autosave comparison ignores ids and __typename from the query.
const toConsignmentFormValues = consignment =>
  consignment
    ? {
        ...consignment,
        [SOURCING_PEOPLE_FIELD]: toSalesPeopleRows(
          consignment[SOURCING_PEOPLE_FIELD] || [],
        ),
      }
    : consignment;

// Sourcing people are saved with their own mutation, so they are split off
// from the fields sent to updateConsignment.
const separateSourcingPeople = (values = {}, savedValues = {}) => ({
  consignmentValues: _.omit(values, SOURCING_PEOPLE_FIELD),
  savedConsignmentValues: _.omit(savedValues, SOURCING_PEOPLE_FIELD),
  sourcingPeople: values?.[SOURCING_PEOPLE_FIELD] || [],
  sourcingPeopleChanged: !_.isEqual(
    values?.[SOURCING_PEOPLE_FIELD] || [],
    savedValues?.[SOURCING_PEOPLE_FIELD] || [],
  ),
});

export {
  SOURCING_PEOPLE_FIELD,
  separateSourcingPeople,
  toConsignmentFormValues,
};
